
import { Component, Vue } from 'vue-property-decorator';
import { BASE_API_URL, REXQO_APP_ID } from '@/constants';
import { httpStore,currentUserStore } from '@/store/typed';

import ProductCustomization from '@/models/ProductCustomization';
import qs from 'qs';
export enum ProductCustomizationMixinTags {
	Show = "ShowProductCustomization",
	Create = "CreateProductCustomization",
	Upload = "UploadProductCustomization",
	Destroy = "DestroyProductCustomization",
	SetCustomizing = "SetProductCustomizationCustomizing",
	SetTerms = "SetProductCustomizationTerms"

}

@Component
export default class ProductCustomizationMixin extends Vue {

	createProductCustomization(data: any) {
		const url = `${BASE_API_URL}product_customizations`;
		return httpStore.request({
			tag: ProductCustomizationMixinTags.Create,
			url: url,
			data: data,
			headers: {'x-app-id': REXQO_APP_ID, 'locale': currentUserStore.lang},
			method: 'POST',
			}) as Promise<ProductCustomization>;
	}

	getProductCustomization(uuid: string,data= {}) {
		const url = `${BASE_API_URL}product_customizations/${uuid}`;
		return httpStore.request({
			tag: ProductCustomizationMixinTags.Create,
			url: url,
			headers: {'x-app-id': REXQO_APP_ID, 'locale': currentUserStore.lang},
			method: 'GET',
			params: data,
			paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'brackets' })
			}) as Promise<ProductCustomization>;
	}

	uploadProductCustomization(uuid: string, data: any) {
		const url = `${BASE_API_URL}product_customizations/${uuid}/upload`;
		return httpStore.request({
			tag: ProductCustomizationMixinTags.Upload,
			url: url,
			noParse: true,
			data: data,
			headers: {'x-app-id': REXQO_APP_ID, 'locale': currentUserStore.lang},
			method: 'POST',
			}) as Promise<ProductCustomization>;
	}

	deleteProductCustomization(uuid: string) {
		const url = `${BASE_API_URL}product_customizations/${uuid}`;
		return httpStore.request({
			tag: ProductCustomizationMixinTags.Destroy,
			url: url,
			noParse: true,
			headers: {'x-app-id': REXQO_APP_ID, 'locale': currentUserStore.lang},
			method: 'DELETE',
			}) as Promise<ProductCustomization>;
	}

	setProductCustomizationCustomizing(data: any) {
		const url = `${BASE_API_URL}product_customizations/${data.id}/stat`;
		return httpStore.request({
			tag: ProductCustomizationMixinTags.SetCustomizing,
			url: url,
			noParse: true,
			data: {column: 'last_customized_at'},
			headers: {'x-app-id': REXQO_APP_ID, 'locale': currentUserStore.lang},
			method: 'POST',
			}) as Promise<ProductCustomization>;
	}

	setProductCustomizationTerms(data: any) {
		const url = `${BASE_API_URL}product_customizations/${data.id}/stat`;
		return httpStore.request({
			tag: ProductCustomizationMixinTags.SetTerms,
			url: url,
			noParse: true,
			data: {column: 'terms_accepted_at'},
			headers: {'x-app-id': REXQO_APP_ID, 'locale': currentUserStore.lang},
			method: 'POST',
			}) as Promise<ProductCustomization>;
	}
}
